import { ReportsService } from '@treasury/domain/backoffice/services/reports/reports-service';
import UserActivityReportsService from '@treasury/domain/backoffice/services/reports/user-activity-reports-service';

export default class UserActivityReportClient {
    async getActivityTypes(...args) {
        return UserActivityReportsService.getActivityTypes(...args);
    }

    async getCompanies(...args) {
        return UserActivityReportsService.getCompanies(...args);
    }

    async getCompanyUsers(...args) {
        return UserActivityReportsService.getCompanyUsers(...args);
    }

    async getAllUsers(...args) {
        return UserActivityReportsService.getAllUsers(...args);
    }

    async runChannelUserActivityReport(...args) {
        return UserActivityReportsService.getChannelUserActivity(...args);
    }

    async runBackOfficeUserActivityReport(...args) {
        return UserActivityReportsService.getBackOfficeUserActivity(...args);
    }

    async downloadUserActivityReport(...args) {
        return UserActivityReportsService.downloadUserActivityReport(...args);
    }

    async saveReport(...args) {
        return UserActivityReportsService.saveReport(...args);
    }

    async getCustomReportFilters(...args) {
        return ReportsService.getCustomReportFilters(...args);
    }
}
